"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SystemEventName;
(function (SystemEventName) {
    /**
     * Поступление телефонного звонка
     * "Поступление телефонного звонка с номера {0}, канал: {1} группы #{4} {5} оператору #{2} {3}. Время поступления: {6}. IP звонящего: {11}"
     */
    SystemEventName["PhoneBegin"] = "PhoneBegin";
    /**
     * Завершение телефонного звонка
     * "Завершение телефонного звонка с номера {0}, канал: {1} группы #{4} {5} оператор #{2} {3}. Время поступления {6}, время окончания {13}"
     */
    SystemEventName["PhoneEnd"] = "PhoneEnd";
    /**
     * Регистрация телефонного звонка
     * "Регистрация телефонного звонка: {0}. Номер: {1} Канал: {2} группы #{6} {7}. Время поступления: {5}."
     */
    SystemEventName["CallRegistered"] = "CallRegistered";
    /**
     * Диспетчер нажал кнопку при звонке
     * "При звонке с номера {0} на канал {1} группы #{6} {7} диспетчер #{3} {4} (IP {5}) нажал кнопку {2}."
     */
    SystemEventName["PhoneButtonPressed"] = "PhoneButtonPressed";
    /**
     * Статус SIP канала изменен
     * "Статус канала {0} сотрудника (#{1},IP адрес:{2}) изменен на статус {3}"
     */
    SystemEventName["PhoneChannelStatusChanged"] = "PhoneChannelStatusChanged";
    /**
     * Истекло время отправки повторной регистрации SIP канала
     * "Канал {0} сотрудник (#{1},IP адрес:{2})"
     */
    SystemEventName["SipRegistrationExpired"] = "SipRegistrationExpired";
    /**
     * Запрос на регистрацию канала SIP серверу
     * "Запрос к SIP серверу на регистрацию канала {0}. Сотрудник: {1}, IP адрес:{2}"
     */
    SystemEventName["RequestForChannelRegistration"] = "RequestForChannelRegistration";
    /**
     * Оператор принял звонок
     * "Оператор #{0} {1} принял звонок с номера {2}, канал {3} группы #{4} {5}."
     */
    SystemEventName["CallConnected"] = "CallConnected";
    /**
     * При завершении звонка возникли проблемы
     * "При завершении звонка возникли проблемы. Номер {0}, канал {1} группы #{2},  время поступления: {3}, время соединения: {4}. Оператор {5}, ID#{6}."
     */
    SystemEventName["CallWasNotFinishedCorrectly"] = "CallWasNotFinishedCorrectly";
    /**
     * "Диспетчер сбросил звонок"
     * При звонке с номера {0} на канал {1} группы #{2} {3} диспетчер #{4} {5} сбросил звонок."
     */
    SystemEventName["DispatcherDroppedCall"] = "DispatcherDroppedCall";
    SystemEventName["CompleteCurrentAction"] = "CompleteCurrentAction";
    SystemEventName["WebIncomingCall"] = "WebIncomingCall";
})(SystemEventName = exports.SystemEventName || (exports.SystemEventName = {}));
var SystemEventParameterName;
(function (SystemEventParameterName) {
    SystemEventParameterName["PhoneNumber"] = "PhoneNumber";
    SystemEventParameterName["ChannelInfo"] = "ChannelInfo";
    SystemEventParameterName["EmployeeId"] = "EmployeeId";
    SystemEventParameterName["EmployeeName"] = "EmployeeName";
    SystemEventParameterName["GroupId"] = "GroupId";
    SystemEventParameterName["GroupName"] = "GroupName";
    SystemEventParameterName["StartTime"] = "StartTime";
    SystemEventParameterName["ChannelId"] = "ChannelId";
    SystemEventParameterName["CallState"] = "CallState";
    SystemEventParameterName["IsIncomingCall"] = "IsIncomingCall";
    SystemEventParameterName["ApplicationType"] = "ApplicationType";
    SystemEventParameterName["IpAddress"] = "IpAddress";
    SystemEventParameterName["CallId"] = "CallId";
    SystemEventParameterName["ConnectionTime"] = "ConnectionTime";
    SystemEventParameterName["EndTime"] = "EndTime";
    SystemEventParameterName["ChannelOwnerId"] = "ChannelOwnerId";
    SystemEventParameterName["CallType"] = "CallType";
    SystemEventParameterName["CustomerId"] = "CustomerId";
    SystemEventParameterName["Time"] = "Time";
    SystemEventParameterName["PhoneButtonName"] = "PhoneButtonName";
    SystemEventParameterName["UserName"] = "UserName";
    SystemEventParameterName["ChannelIdentifier"] = "ChannelIdentifier";
    SystemEventParameterName["SipChannelStatus"] = "SipChannelStatus";
})(SystemEventParameterName = exports.SystemEventParameterName || (exports.SystemEventParameterName = {}));
//# sourceMappingURL=SystemEvents.js.map